import { render, staticRenderFns } from "./agentedit.vue?vue&type=template&id=4298ef2c&scoped=true&"
import script from "./agentedit.vue?vue&type=script&lang=js&"
export * from "./agentedit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4298ef2c",
  null
  
)

export default component.exports